module.exports = __webpack_public_path__ + "img/logo.6095aeb3.webp";